import UpdateBusinessFormWithCompose, {
  UpdateBusinessForm,
} from './UpdateBusinessForm';
export { UpdateBusinessForm };
export default UpdateBusinessFormWithCompose;
